import(/* webpackMode: "eager" */ "/codebuild/output/src1175232097/src/src/app/[locale]/page.tsx");
